import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    EmployeeBandDto, EmployeeBandPaginator,
    CreateEmployeeBandDto, QueryEmployeeBandDto,
    UpdateEmployeeBandDto,
    SearchEmployeeBandDto
} from "../models/employee-band.dto";
import ENDPOINTS from "./utils/endpoints";

export function useGetEmployeeBand(options?: QueryEmployeeBandDto) {
    const url = ENDPOINTS.PROCESSING_COMPANY.EMPLOYEE_BAND.GET;
    const request = (options: QueryEmployeeBandDto) => API.ProcessingCompanyAPI.getEmployeeBand(options);

    const { data, isLoading, error, refetch } = useQuery<EmployeeBandPaginator, Error>(
        [url, options],
        ({ queryKey, pageParam }) => request(Object.assign({}, queryKey[1], pageParam)),
        {...API.Handlers.pageParamOption}
    );

    return { data, isLoading, error, refetch }
}

export function useGetEmployeeBandSearch() {
    const queryClient = useQueryClient();

    return useMutation(
        (options?: SearchEmployeeBandDto) => API.ProcessingCompanyAPI.getEmployeeBandSearch(options),
        {
            onSuccess: () => {
                //toast.success('Record created successfully');
            },
            onError: API.Handlers.onErrorHandler,
            onSettled: () => {
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.EMPLOYEE_BAND.GET);
            },
        },
    );
}

export function useGetEmployeeBandById(id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.EMPLOYEE_BAND.DETAIL
    const request = API.ProcessingCompanyAPI.getEmployeeBandById(id);

    const {data, isLoading, error} = useQuery<{ data:EmployeeBandDto }, Error>(
        [url, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}
export function useCreateEmployeeBand() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload}: {payload: CreateEmployeeBandDto}) => API.ProcessingCompanyAPI.createEmployeeBand(payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.EMPLOYEE_BAND.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdateEmployeeBand() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, id}: {payload: UpdateEmployeeBandDto, id: number}) => API.ProcessingCompanyAPI.updateEmployeeBand(id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.EMPLOYEE_BAND.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeleteEmployeeBand() {

    return useMutation(
        ({ id}: {id: number}) => API.ProcessingCompanyAPI.deleteEmployeeBand(id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUploadEmployeeBand() {

    return useMutation(
            ({ payload, companyId }: { payload: FormData; companyId: number }) =>
                API.ProcessingCompanyAPI.uploadEmployeeBand(companyId, payload),
            {
                onSuccess: () => {
                },
                onError: API.Handlers.onErrorHandler,
                onSettled: () => {},
            }
        );
}